<template>
  <div
    v-click-outside="handleClickOutside"
    :class="`formulate-input-element formulate-input-element--${context.type} input-${size}`"
    :data-type="context.type"
  >
    <FormulateSlot name="prefix" :context="context">
      <component
        :is="context.slotComponents.prefix"
        v-if="context.slotComponents.prefix"
        :context="context"
      />
    </FormulateSlot>

    <div :class="computedClassInput" @click="handleClickInput">
      <input
        v-if="context.model === ''"
        :placeholder="attrs.placeholder || context.label"
        style="border: 0"
        readonly
      />
      <div class="selected" v-else>
        {{ computedValue }}
      </div>
    </div>

    <FormulateSlot name="suffix" :context="context">
      <component
        :is="context.slotComponents.suffix"
        v-if="context.slotComponents.suffix"
        :context="context"
      />
    </FormulateSlot>

    <div v-if="isOpen" class="popup-picker" :class="{ opened: isOpen }" ref="popup">
      <b-row class="popup-picker__row">
        <b-col v-for="option in optionItems" :key="option.key" class="popup-picker__col">
          <div class="popup-picker__dropdown-items flex flex-column gap-2 p-2">
            <div
              v-for="item in option.items"
              class="popup-picker__dropdown-item"
              :class="{ selected: selectedValues[option.key] === item }"
            >
              <input
                v-model="selectedValues[option.key]"
                type="checkbox"
                :id="`${option.key}-${item}`"
                :value="item"
                :checked="() => isChecked({value: item, key: option.key})"
                @change="() => handleChangeCheckbox({value: item, key: option.key})"
              />
              <label :for="`${option.key}-${item}`" class="text-center">{{
                new Intl.NumberFormat('en-US', { minimumIntegerDigits: 2 }).format(item)
              }}</label>
            </div>
          </div>
        </b-col>
      </b-row>

      <div class="popup-picker__footer">
        <McButton text="Terapkan" class="mt-2 w-100" @click="handleApply" />
      </div>
    </div>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

import moment from 'moment'
import { isEmpty, cloneDeep } from 'lodash';

export default {
  components: {
    McButton,
  },
  props: {
    context: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
    optionItems: {
      type: Array,
      default: () => {
        return [
          {
            key: 'days',
            items: [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
              24, 25, 26, 27, 28, 29, 30,
            ],
          },
          {
            key: 'hours',
            items: [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
            ],
          },
        ]
      },
    },
  },
  emits: ['change-popup-state'],
  data() {
    return {
      isOpen: false,
      selectedValues: {},
      initialSelectedValues: {},
      mapping: {
        days: 'Hari',
        hours: 'Jam',
        minutes: 'Menit',
      },
    }
  },
  computed: {
    attrs() {
      return this.context.attributes
    },
    computedClassInput() {
      let className = `mc-input d-inline-flex input-${this.size}`

      if (this.attrs.disabled) {
        className += ' __disabled'
      }

      return className
    },
    computedValue() {
      let duration = moment.duration(this.context.model)

      if (this.isOpen) {
        duration = moment.duration(this.selectedValues)
      }

      let value = ''

      this.optionItems.forEach((option) => {
        value += `${String(duration.get(option.key) || 0).padStart(2, '0')} ${this.mapping[option.key]} `
      })

      return value
    },
  },
  mounted() {
    // get initialValue of the input
    if (this.attrs?.initialValues && isEmpty(this.selectedValues)) {
      const initialDuration = moment.duration(this.attrs.initialValues)
      this.context.model = initialDuration.toISOString()
    }
  },
  methods: {
    handleClickInput(type) {
      if (type === 'popup' || this.attrs.disabled) return

      this.isOpen = !this.isOpen
      this.$nextTick(() => {
        this.$emit('change-popup-state', this.$refs.popup)
      })

      if (!this.isOpen) return

      const currentValue = moment.duration(this.context.model || (this.attrs && this.attrs.initialValues) || {})

      this.optionItems.forEach(option => {
        this.$set(this.selectedValues, option.key, currentValue.get(option.key) || null)
        this.$set(this.initialSelectedValues, option.key, currentValue.get(option.key) || null)
      })
    },
    handleClickOutside() {
      this.selectedValues = cloneDeep(this.initialSelectedValues)
      this.initialSelectedValues = {}

      this.isOpen = false
    },
    isChecked({ value, key }) {
      return this.selectedValues[key] === value;
    },
    handleChangeCheckbox({ value, key }) {
      if (this.selectedValues[key] === value) {
        // If the same checkbox is clicked, deselect it
        this.$set(this.selectedValues, key, null)
        return
      }

      // Otherwise, select the new value
      this.$set(this.selectedValues, key, value)
    },
    handleApply() {
      const newValue = moment.duration(this.selectedValues)
      this.context.model = newValue.toISOString()

      this.selectedValues = {}
      this.initialSelectedValues = {}
      this.isOpen = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
